/**
 * QL-431 — the selected type inside a row's Type select. A long label is
 * truncated with an ellipsis, but the required `*` never shrinks, so it stays
 * visible when the select is narrow (laptop screens).
 */
export function RequiredTypeLabel({ label, required }: { label: string; required: boolean }) {
  return (
    <span className="flex min-w-0 items-center">
      <span className="truncate">{label}</span>
      {required && <span className="shrink-0 text-destructive">&nbsp;*</span>}
    </span>
  );
}
